import PageHero from '../shared/PageHero.jsx';
import StatBand from '../shared/StatBand.jsx';
import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import TeacherGrid from '../components/TeacherGrid.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { aboutIntro, aboutStats, beliefs } from '../constants/about.js';
import mainPhoto from '../assets/images/main.jpg';

export default function About() {
  return (
    <>
      <Seo {...metaFor('/about')} path="/about" />

      <PageHero
        eyebrow={aboutIntro.eyebrow}
        title={aboutIntro.title}
        lede={aboutIntro.lede}
      />

      <section className="bg-cream pb-20 pt-5">
        <div className="mx-auto grid max-w-[1240px] items-center gap-11 px-5 sm:px-8 lg:grid-cols-[1.05fr_0.95fr]">
          <Reveal>
            <h2 className="font-display text-[34px] font-extrabold leading-[1.06] text-forest">
              What we actually believe
            </h2>
            <ol className="mt-4.5 flex flex-col gap-4">
              {beliefs.map((belief, i) => (
                <li key={belief.title} className="flex gap-3.5">
                  <span
                    aria-hidden="true"
                    className="flex size-[38px] flex-none items-center justify-center rounded-xl bg-mint font-display font-extrabold text-forest"
                  >
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="text-[17px] font-extrabold text-ink">{belief.title}</h3>
                    <p className="mt-1 text-[15.5px] leading-[1.55] text-ink-soft">
                      {belief.body}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </Reveal>

          <Reveal className="aspect-[4/3.4] overflow-hidden rounded-[34px] border-[5px] border-white shadow-[0_18px_38px_rgb(20_83_45_/_0.16)]">
            <ImageSlot
              src={mainPhoto}
              alt="Pupils and teachers gathered in the school courtyard"
            />
          </Reveal>
        </div>
      </section>

      <StatBand stats={aboutStats} />

      <section className="bg-cream py-20">
        <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
          <Reveal>
            <p className="font-hand text-[23px] text-coral">
              The people walking with them
            </p>
            <h2 className="mt-1.5 font-display text-[clamp(30px,3.6vw,48px)] font-extrabold leading-[1.04] text-forest">
              Teachers who stay long enough to matter
            </h2>
          </Reveal>
          <div className="mt-[34px]">
            <TeacherGrid />
          </div>
        </div>
      </section>
    </>
  );
}
